/**
 * Remove stray /en after market prefixes (e.g. /de-de/en → /de-de).
 * Root / is NL/BE home; visitors from other countries (unknown GeoIP included) hitting / go to /en. Geo strips /en when building targets.
 * Runs on every load; must stay above geo early-returns.
 */
(function stripSpuriousMarketEn() {
  try {
    const path = window.location.pathname;
    const withoutEn = path.replace(
      /^(\/(?:nl-be|de-de|fr-fr|de|fr))\/en(?=\/|$)/,
      '$1',
    );
    if (withoutEn === path) return;
    const noDupSlash =
      withoutEn.length > 1 ? withoutEn.replace(/\/+$/, '') || '/' : withoutEn;
    window.history.replaceState(
      null,
      '',
      noDupSlash + window.location.search + window.location.hash,
    );
  } catch (_) {}
})();

/**
 * First-visit (per session) redirect from visitor country → market URL prefix.
 * Uses third-party GeoIP (ipapi.co, then ipwho.is). Disclose in privacy policy / cookie notice.
 */
(function geoRedirect() {
  const STORAGE_KEY = 'triat_geo_redirect_v1';

  if (typeof sessionStorage === 'undefined') return;
  if (sessionStorage.getItem(STORAGE_KEY)) return;
  if (new URLSearchParams(window.location.search).has('geo_skip')) {
    sessionStorage.setItem(STORAGE_KEY, 'skip_param');
    return;
  }
  if (window.Shopify && window.Shopify.designMode) return;

  /** @type {Record<string, string>} ISO 3166-1 alpha-2 → path segment (empty = root / for NL & BE) */
  const COUNTRY_TO_PREFIX = {
    BE: '',
    DE: 'de',
    FR: 'fr',
    NL: '',
  };

  /** Longer prefixes first; `en` = default locale URL (first load), not the BE→NL selector root */
  const LOCALE_SEGMENTS = ['nl-be', 'de-de', 'fr-fr', 'de', 'fr', 'en'];

  function normalizePath(pathname) {
    if (pathname === '/' || pathname === '') return '/';
    return pathname.replace(/\/+$/, '') || '/';
  }

  /**
   * Strip leading market/locale segments repeatedly (e.g. /de-de/en/shop → /shop).
   * @param {string} pathname
   * @returns {string}
   */
  function stripLocalePath(pathname) {
    let path = pathname;
    let changed = true;
    while (changed) {
      changed = false;
      for (const seg of LOCALE_SEGMENTS) {
        const base = `/${seg}`;
        if (path === base || path.startsWith(`${base}/`)) {
          path = path.slice(base.length) || '/';
          if (!path.startsWith('/')) path = `/${path}`;
          changed = true;
          break;
        }
      }
    }
    return path;
  }

  /**
   * @param {string} country
   * @param {string} pathname
   * @returns {string | null}
   */
  function buildPathForCountry(country, pathname) {
    if (!Object.prototype.hasOwnProperty.call(COUNTRY_TO_PREFIX, country)) return null;
    const rest = stripLocalePath(pathname);
    const prefix = COUNTRY_TO_PREFIX[country];
    if (!prefix) {
      return normalizePath(rest);
    }
    if (rest === '/') {
      return `/${prefix}`;
    }
    return normalizePath(`/${prefix}${rest}`);
  }

  function pathsEquivalent(a, b) {
    return normalizePath(a) === normalizePath(b);
  }

  /**
   * @param {string | null} country
   * @param {string} pathname
   * @returns {string | null}
   */
  function resolveDesired(country, pathname) {
    const norm = normalizePath(pathname);
    if (
      norm === '/' &&
      (!country ||
        !Object.prototype.hasOwnProperty.call(COUNTRY_TO_PREFIX, country))
    ) {
      return '/en';
    }
    if (!country) {
      return null;
    }
    return buildPathForCountry(country, pathname);
  }

  function markDone() {
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  async function detectCountry() {
    try {
      const r = await fetch('https://ipapi.co/json/', { credentials: 'omit' });
      if (r.ok) {
        const j = await r.json();
        if (j && j.country_code) return String(j.country_code).toUpperCase();
      }
    } catch (_) {}
    try {
      const r = await fetch('https://ipwho.is', { credentials: 'omit' });
      if (r.ok) {
        const j = await r.json();
        if (j && j.success !== false && j.country_code) {
          return String(j.country_code).toUpperCase();
        }
      }
    } catch (_) {}
    return null;
  }

  detectCountry()
    .then((country) => {
      const desired = resolveDesired(country, window.location.pathname);
      const stay =
        desired === null ||
        pathsEquivalent(window.location.pathname, desired);
      markDone();
      if (!stay) {
        window.location.replace(
          `${desired}${window.location.search}${window.location.hash}`,
        );
      }
    })
    .catch(() => {
      markDone();
    });
})();
